import { httpClientPrivate } from '@/libs/httpClient'
import { CrashDetectionListResponse } from '../types'
import config from '@/config'
import { useQuery } from '@tanstack/react-query'

const fetchCrashDetectionList = async (params: {
  search?: string
  page: number
  limit: number
  sortBy?: string
  filter?: string
}) => {
  const search = params.search ? `search=${params.search}&` : ''
  const sortBy = params.sortBy ? `&sortBy=${params.sortBy}` : ''
  const filter = params.filter ? `&${params.filter}` : ''

  const { data } = await httpClientPrivate.get<CrashDetectionListResponse>(
    `${config.restUrl}/v1/backoffice/crash-detection?${search}page=${params.page}&limit=${params.limit}${sortBy}${filter}`,
  )

  return data
}

const useCrashDetectionList = (params: {
  search?: string
  page: number
  limit: number
  sortBy?: string
  filter?: string
  enabled?: boolean
  refetchInterval?: number | false
}) => {
  const queryKey = ['useCrashDetectionList', params]
  const queryFn = async () => fetchCrashDetectionList(params)
  const queryResult = useQuery({
    queryKey,
    queryFn,
    enabled: params.enabled !== false,
    refetchInterval: params.refetchInterval,
  })

  return { ...queryResult }
}

export { fetchCrashDetectionList, useCrashDetectionList }
